import { useContext } from 'react';
import { Link } from 'react-router-dom';
import MyContext from '@/shared/contexts/AppContext';
import Links from '@/shared/constants/navegacao';

export default function RelatoriosEscolhaModuloButton(props: { className?: string }) {
  const context = useContext(MyContext);
  if (!context) return null;

  const { state } = context;

  const navbarVisivel = state.navbar;

  if (navbarVisivel) return null;

  return (
    <Link to={Links.Escolha_Modulo} className={`btn btn-outline-secondary btn-sm ${props.className || ''}`.trim()}>
      Escolha de módulo
    </Link>
  );
}

